<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="7">
						<el-form-item>
							<el-input style="width:200px;margin-right: 10px;" placeholder="请输入关键字" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable></el-input>
							<el-button @click="clickSearch" icon="el-icon-search" type="warning">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="状态" :label-width="'80px'">
							<el-select style="width:120px" v-model="search.status" @change="changeSearch">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'寄养中',value:1},{label:'寄养结束',value:2}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="5">
						<el-form-item label="入住状态" :label-width="'80px'">
							<el-select style="width:120px"  v-model="search.isPay" @change="changeSearch">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'未入住',value:1},{label:'已入住',value:0}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="2">
						<resetBtn @reset="reset"></resetBtn>
					</el-col>
					<el-col :span="1">
						<el-col :span="2" style="float: right;">
							<!-- <el-button @click="$router.push({path:'/yiliao/guahaoAdd'})" icon="el-icon-plus" type="primary">新建</el-button> -->
						</el-col>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="pageConBox">
			<el-table :data="tableData" style="width: 100%" >
				<!-- <el-table-column label="编码" width="50">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column> -->
				<el-table-column label="单号" prop="careId" width="100">
					<template slot-scope="props">
						<span>{{props.row.careId}}</span>
					</template>
				</el-table-column>
				<el-table-column label="顾客" prop="memberName" min-width="120">
					<template slot-scope="props">
						<div>{{props.row.memberName}}</div>
						<div>{{props.row.memberMobile}}</div>
					</template>
				</el-table-column>
				<el-table-column label="宠物" prop="petName" min-width="160">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<el-button type="text" size="mini" @click="$router.push({path:'/jiyang/jiyangEdit?sid='+item.recordId})">查看</el-button>
							<el-button v-if="item.status!==2" style="margin-left:5px;" type="text" size="mini" @click="$router.push({path:'/jiyang/jiyangEdit?eid='+item.recordId})">编辑</el-button>
							{{item.petName}}
						</div>
					</template>
				</el-table-column>
				
				<el-table-column label="寄养状态" min-width="80">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<span v-if="item.status===1">寄养中</span>
							<span v-if="item.status===2">寄养结束</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="寄养时间" min-width="190">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<el-popover placement="top-start" width="320" trigger="hover">
								<div>{{$public.FTime(item.beginDate)}} ~ {{$public.FTime(item.beginDate)}}</div>
								<div slot="reference">{{$public.FTime(item.beginDate,"MM-DD HH:mm")}} ~ {{$public.FTime(item.endDate,"MM-DD HH:mm")}}</div>
							</el-popover>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="入住房间" width="200">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<div v-if="item.joinCage==1">
						        {{item.cageInfo.positionName}}{{item.cageInfo.cageName}} 
                       <el-button type="text" size="mini" @click="changeCage(item,type)">搬家</el-button>
                       <el-button type="text" size="mini" @click="removeCage(item)">移出</el-button>
					</div>
					<div v-if="item.joinCage==0&&item.status==2&&item.cageInfo">
						        {{item.cageInfo.positionName}}{{item.cageInfo.cageName}} 
					</div>
					<el-button v-if="item.joinCage==0&&item.status==1" type="text" size="mini" @click="AddCage(item,type)">入住</el-button>
					</div>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="doctorName" min-width="50">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<el-popover v-if="item.remark" placement="top-start" width="200" trigger="hover" :content="item.remark">
								<i class="el-icon-view" style="margin-left: 4px;" slot="reference"></i>
							</el-popover>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="押金" prop="deposit" min-width="60">
					<template slot-scope="props">
						{{props.row.deposit}}
					</template>
				</el-table-column>
				<el-table-column label="创建人" prop="createUserName" min-width="80">
				</el-table-column>
				<el-table-column label="销售日期" prop="doctorName" min-width="150">
					<template slot-scope="props">
						{{$public.FTime(props.row.createTime)}}
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="120">
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button type="text" size="mini" @click="print(props.row)">打印小票</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<jiyangSee v-if="drawerJiyangSee_state" :curItem="curItem" @close="submit_drawerJiyangSee"></jiyangSee>
		<iframe v-if="printUrl" :src="'ChuLinPrint:'+printUrl" width="0" height="0"></iframe>
		<div v-if="petCageState">
        <drawerJiYangPetCage
          :petId="petId"
		  :type="type"
		  :apply_type="apply_type"
          @submit="submit_drawerStatus"
        ></drawerJiYangPetCage>
      </div>
	  <div v-if="petCageAddState">
        <drawerJiYangAddPetCage
          :petId="petId"
		  :apply_type="apply_type"
          @submit="submit_drawerAddStatus"
        ></drawerJiYangAddPetCage>
      </div>
	</div>
</template>
<script>
import drawerJiYangPetCage from "../../../components/drawerPetCage/drawer_JiYangPetCage.vue";
import drawerJiYangAddPetCage from "../../../components/drawerPetCage/drawer_JiYangAddPetCage.vue";	
import page from "../../../components/page.vue"
	import resetBtn from "../../../components/resetBtn.vue"
	import jiyangSee from "../../mendian/shouyin/drawer/jiyangSee.vue"
	import printJs from "../../../util/print.js"
	export default {
		components:{page,resetBtn,jiyangSee,drawerJiYangPetCage,drawerJiYangAddPetCage},
		data(){
			return{
				search:{
					keyword:'',
					"startDate": "",
					"endDate": "",
					"status": -1,  // -1全部；1寄养中；2 寄养完成
					"depositType": 0,
					"petId": "",
				},
				datetimerange:'',
				tableData:[],
				curItem:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				 // 宠物笼子
				 petCageState: false,
				drawerJiyangSee_state:false,
				petCageAddState:false,
				printUrl:'',
				type:'change',
				petId:'',
				qwe:'',
				qwe1:'',
				apply_type:'', //猫狗分类
			}
		},
		watch:{
			
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// 入住
			AddCage(item){
                this.petId=item.petId;
				this.qwe1=item;
				this.apply_type=item.classType
				this.petCageAddState = true;
			},
			submit_drawerAddStatus(obj){
					if (obj.type == "submit") {
					   this.qwe1.cageInfo=obj.cageInfo
						this.getTableData();
                       this.petCageAddState = false;
					}else{
						this.petCageAddState = false;
					}
					
					
				},
				// 搬家
			changeCage(item,type){
				this.petId=item.petId;
				this.qwe=item.cageInfo;
				this.apply_type=item.classType
				type="change"
				this.petCageState = true;
			},
			submit_drawerStatus(obj) {
				console.log(obj,"搬家");
				if (obj.type == "submit") {
				this.qwe.positionId=obj.positionId
				this.qwe.positionName=obj.positionName
				this.qwe.cageId=obj.cageId
				this.qwe.cageName=obj.cageName
				this.getTableData();
                this.petCageState = false;
				}else{
					this.petCageState = false;
				}
				
                },
			reset(){
				this.search = {
					keyword:'',
					"startDate": "",
					"endDate": "",
					"status": -1,  // -1全部；1寄养中；2 寄养完成
					"depositType": 0,
					"petId": "",
				};
				this.page.page=1;
				this.getTableData()
			},
			print(row){
				this.$http.get('/api/Order/FosterCareOrderReceipt', {
					careId: row.careId
				}).then(res => {
					if (res.code == 0) {
						let d = res.data;
						printJs.printTicketSaleOrder(d).then(r => {
							this.$store.commit("set_printUrl",r.msg)
							// if (r.url != '') {
							// 	this.printUrl = r.url;
							// 	setTimeout(() => {
							// 		this.printUrl = '';
							// 	}, 1000)
							// }
						})
					}
				})
			},
			// 查看
			see(row){
				this.curItem = row;
				this.drawerJiyangSee_state = true;
			},
			submit_drawerJiyangSee(){
				this.drawerJiyangSee_state = false;
				this.getTableData();
			},
			
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			
				
			// 移出
			removeCage(item){
					console.log(item,"??????row");
				this.$confirm('确定要把宠物移出笼子?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_apiHost +'api/FosterCare/removeCage', {petId:item.petId}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '移出成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Case/Delete', {caseNumber:row.caseNumber}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"startDate": "",
					"endDate": "",
					"status": this.search.status,  // -1全部；1寄养中；2 寄养完成
					"depositType": this.search.depositType,
					"petId": this.search.petId,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": (this.search.keyword).trim(),
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.startDate=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.endDate=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				this.$http.post('/api/FosterCare/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox{
		.el-form-item{
			margin-bottom:0;
		}
	}
	.pageConBox{
		min-height: 600px;
	}
}
</style>
